import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,

    Paper,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, SyncData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import PrintIcon from '@mui/icons-material/Print';
import Info from '@mui/icons-material/Info';
import ReactDOM from 'react-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import CircularProgress from '@mui/material/CircularProgress';
// import InvoicePrint from './Estimate';
// import NongstBillPrint from './Bill';
import InvoicePrint from './../Invoice/Estimate';
import NongstBillPrint from './../Invoice/Bill';
import { Tooltip } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function MonthlySaleReport() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [loading, setLoading] = useState(false);
    const [saleOrderId, setsaleOrderId] = useState(false);

    const [orderBy, setOrderBy] = useState('');
    const [order, setOrder] = useState('asc');
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');
    const branchId = 0;

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        setFromDate(getMonthStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getMonthStartDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
        return `${year}-${month}-01`; // Format as 'YYYY-MM-DD'
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(1000); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([

        'SL No',
        'Customer Name',
        'GST No ',
        'Bill No.',
        'Bill Amount',
        'CGST',
        'SGST',
        'IGST',
        'Total'

    ]);

    // Process and paginate the data
    const processedData = filteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const sortedData = stableSort(filteredData, getComparator(order, orderBy));

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };

    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    // Fetch data from the API

    const fetchTableData = async () => {
        console.log("Fetching with:", { fromDate, toDate });

        if (!fromDate || !toDate) {
            console.error("Missing date values. Skipping API call.");
            return;
        }

        setLoading(true);
        try {
            const response = await fetchData(
                'MonthlyWiseSaleReportApi',
                `/CustomerDetails/${companyId}/${fromDate}/${toDate}`,
                token
            );

            if (response.responseCode === '1111') {
                // Map data to add BillPrefix and full InvoiceNumber
                const mappedData = response.response_data.map((sale) => {
                    const BillPrefix = sale.TaxMethod === 1 ? "BB" :
                        sale.TaxMethod === 2 ? "C" : "E";

                    const BillType = sale.TaxMethod === 1 ? "GST Bill" :
                        sale.TaxMethod === 2 ? "Tax Bill" : "Estimate Bill";

                    return {
                        ...sale,
                        BillPrefix,
                        BillType,
                        InvoiceNumberWithPrefix: `${BillPrefix}${sale.InvoiceNumber}/${sale.FinYear}`
                    };
                });

                setData(mappedData);
            } else {
                console.error("Unexpected response:", response);
            }
        } catch (error) {
            console.error("Error fetching Sale Details:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        deleteData('MonthlyWiseSaleReportApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchTableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('SaleApi', `${itemId}`, token)
            .then(() => {
                fetchTableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const calculateTotals = (data) => {
        const totalAmount = data.reduce((sum, row) => sum + row.Amount, 0);
        const grandTotal = data.reduce((sum, row) => sum + row.TotalAmount, 0);
        return { totalAmount, grandTotal };
    };

    const { totalAmount, grandTotal } = calculateTotals(filteredData);


    const handleSaleOrderPrint = async (saleOrderId) => {
        try {
            // Fetch data
            const response = await fetchData('SaleOrderApi', `/SaleorderPrint/${saleOrderId}`, token);
            const labelData = Array.isArray(response.response_data) ? response.response_data : [response.response_data];

            // Create iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Write component content to iframe
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                labelData[0].SaleOrderPrint.IsGST === true ? (
                    <InvoicePrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />
                ) : (
                    <NongstBillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />
                ),
                iframeDocument.body
            );


            iframeDocument.write('</body></html>');
            iframeDocument.close();

            // Print the content
            iframe.contentWindow.print();


            try {
                await SyncData('SaleOrderApi', `${saleOrderId}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }
    };





    const exportToExcel = () => {
        // Convert your displayed data (sortedData) to a JSON array for export
        const exportData = sortedData.map((row, index) => ({
            "Sl.No": index + 1,
            "Bill Date": formatDate(row.InvoiceDate),
            "Bill Number": row.InvoiceNumberWithPrefix,
            "Route": row.Route,
            "Customer Name": row.CustomerName,
            "Address": row.AddressLine1,
            "Contact Number": row.CustomerContact,
            "Bill Type": row.BillType,
            "Total Amount": (row.TotalAmount ?? 0).toFixed(2),
        }));

        // Create worksheet and workbook
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Monthly Sales");

        // Export file
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, `MonthlySales_${new Date().toISOString().split("T")[0]}.xlsx`);
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>

            <div className='w-full mb-2 flex'>
                <h6 className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    Sale </h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '300px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginTop: '20px'
                        }}
                    />
                </div>
                <div className="flex w-full md:w-auto justify-center md:justify-start">
                    {/* From Date */}
                    <div className="mr-2 max-w-[150px]">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-1">
                            From
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date"
                            value={fromDate}
                            onChange={handleFromDateChange}
                        />
                    </div>

                    {/* To Date */}
                    <div className="max-w-[150px]">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-1">
                            To
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date"
                            value={toDate}
                            onChange={handleToDateChange}
                        />
                    </div>
                </div>

                <Button
                    onClick={exportToExcel}
                    style={{ backgroundColor: 'rgb(12, 151, 125)', color: 'white', height: '26px', marginRight: '8px', marginTop: '25px', marginLeft: '5px' }}
                >
                    Excel
                </Button>


                <Button
                    style={{ backgroundColor: 'rgb(12, 151, 125)', color: 'white', height: '26px', marginRight: '8px', marginTop: '25px', marginLeft: '5px' }}
                    onClick={fetchTableData}
                    className="linkcolor"
                >
                    <span style={{ fontSize: '11px' }}>Refresh</span>
                </Button>


            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '600px', overflowY: 'auto', marginTop: '-10px' }}>
                <TableContainer component={Paper}>
                    <Table>
                        {/* <TableHead sx={{ backgroundColor: '#58A5B3' }}> */}
                        <TableHead sx={{
                            backgroundColor: 'teal', position: 'sticky', // Makes the header sticky
                            top: 0,             // Locks it to the top
                            zIndex: 1,
                        }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '16px', padding: '5px', color: 'whitesmoke', width: '5%' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '16px', padding: '5px', color: 'whitesmoke', width: '7%' }}>Bill Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '16px', padding: '5px', color: 'whitesmoke', width: '10%' }}>Bill Number</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '16px', padding: '5px', color: 'whitesmoke', width: '15%' }}>Route</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '16px', padding: '5px', color: 'whitesmoke', width: '17%' }}>Customer Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '16px', padding: '5px', color: 'whitesmoke', width: '13%' }}>Contact Number</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '16px', padding: '5px', color: 'whitesmoke', width: '7%' }}>BillType</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '16px', padding: '5px', color: 'whitesmoke', width: '7%', textAlign: 'right' }}>Total Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '16px', padding: '5px', color: 'whitesmoke', width: '7%', textAlign: 'right' }}></TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {/* {filteredData.map((row, index) => ( */}
                            {sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                <TableRow key={row.Id}>
                                    <TableCell sx={{ padding: '3px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{formatDate(row.InvoiceDate)}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{row.BillPrefix}{row.InvoiceNumber}/{row.FinYear}</TableCell>
                                    {/* <TableCell sx={{ padding: '3px' }}>{row.InvoiceNumber}/{row.FinYear}</TableCell> */}
                                    <TableCell sx={{ padding: '3px' }}>{row.Route}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{row.CustomerName} {row.AddressLine1}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{row.CustomerContact}</TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'left' }}>{row.BillType}</TableCell>

                                    <TableCell sx={{ padding: '3px', textAlign: 'right' }}>{(row.TotalAmount ?? 0).toFixed(2)}</TableCell>

                                    <TableCell sx={{ padding: '3px', textAlign: 'left' }}>
                                        <Tooltip title="Print Bill">
                                            <Button
                                                onClick={() => handleSaleOrderPrint(row.SaleOrderId)}
                                                style={{
                                                    backgroundColor: 'orange',
                                                    color: 'whitesmoke',
                                                    height: '25px',
                                                }}
                                            >
                                                <PrintIcon /> {/* Replace "Print" with the Print icon */}
                                            </Button>
                                        </Tooltip>
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>

                        <TableFooter style={{ backgroundColor: '#F6FCDF' }}>
                            <TableRow>
                                <TableCell
                                    colSpan={7}
                                    sx={{
                                        fontWeight: 'bold',
                                        textAlign: 'right',
                                        fontSize: '14px',
                                        color: 'black',
                                    }}
                                >
                                    Total:
                                </TableCell>
                                <TableCell
                                    sx={{
                                        padding: '3px',
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        color: 'black',
                                    }}
                                >
                                    {grandTotal.toFixed(2)}
                                </TableCell>
                                <TableCell></TableCell>
                            </TableRow>

                        </TableFooter>

                    </Table>

                    <TablePagination
                        rowsPerPageOptions={[100, 200, 300, 400, 500]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </div>

            <Dialog open={confirmDialogOpen} onClose={closeConfirmDialog}>
                <DialogTitle>Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeConfirmDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export default MonthlySaleReport;
